export default "__VITE_ASSET__CjJPbK65__"